export { default as DocumentReportOutlineIcon } from './DocumentReportOutlineIcon';
